import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { setSearchQuery } from './redux/modules/search';
import { getSession } from './redux/modules/auth';
// import http2 from './utils/http2';
import { createBoligAgent } from './redux/modules/boligagents';
import facebookSavePrefs from './utils/facebook-save-prefs';
import visitor, { IS_RETURNING } from './utils/visitor';

import App from './App';
import Frontpage from './dwellings/frontpage';
import Search from './dwellings/search';
import Area from './dwellings/area';
import Dwelling from './dwelling/container.connected';
import Cities from './cities';

import Signup from './profile/signup.connected';
import ResetPassword from './profile/reset-password';
import Login from './profile/login';
import Profile from './profile';
import Subscription from './profile/subscription';
import Tenant from './profile/tenant';
import VerifyUser from './profile/verify';
import Transaction from './profile/subscription/transaction';

import ProfileMain from './profile/forms/profile-tab';
import ProfileChangePassword from './profile/forms/change-password.connected';
import ProfileBoligAgents from './profile/boligagent';

import Contact from './info/Contact';
import About from './info/About';
import Faq from './info/Faq';
import Partners from './info/Partners';
import Terms from './info/Terms';
import ShowSearch from './common/show-search';
import Complain from './info/complain';

import ChangeBoligagent from './boligagent/change-boligagent';
import VerifyBoligagent from './boligagent/verify.connected';
import NotFound from './common/not-found';

import Welcome from './static/da/welcome';

import UnsubscriptionForm from './profile/subscription/unsubscription-form';

// eslint-disable-next-line react/display-name
export default store => {
  const validateSearch = (nextState, replace, done) => {
    if (!store.getState().search) {
      store.dispatch(setSearchQuery(nextState.location.query));
    }
    done();
  };

  let userPromise = null;

  const initCheck = (nextState, replace, done) => {
    const auth = store.getState().auth;
    visitor(IS_RETURNING, 1);

    if (auth.token && !auth.user && !userPromise) {
      userPromise = store.dispatch(getSession());
    }

    if (
      Object.keys(nextState.location.query).length > 0 ||
      nextState.params.city
    ) {
      store.dispatch(
        setSearchQuery(nextState.location.query || { q: nextState.params.city })
      );
    }

    done();
  };

  let firstRender = true;

  const requireAuth = (nextState, replace, done) => {
    if (firstRender) {
      firstRender = false;
      return done();
    }

    if (!__CLIENT__) {
      return done();
    }

    const user = store.getState().auth.user;
    if (user) {
      return done();
    }
    if (userPromise) {
      return userPromise
        .then(user => {
          if (!user.payload.token) {
            throw new Error('Missing user token');
          }

          const prefs = facebookSavePrefs();
          if (prefs) {
            store.dispatch(createBoligAgent({ prefs, notVerify: true }));
          }
        })
        .catch(err => {
          if (__DEV__) {
            console.error(err);
          }
          return replace('/login');
        })
        .then(() => done());
    }
    replace('/login');
    done();
  };

  function authCheck(nextState, replace, done) {
    const user = store.getState().auth.user;
    if (user) {
      return userPromise.then(() => {
        const subscriber = store.getState().subscriptions.subscriber;
        replace(subscriber ? '/profile/tenant' : '/profile/subscription');
        done();
      });
    }
    done();
  }

  // @deprecated: to be removed in december, as it should no longer be needed
  function preferSSL(nextState, replace, done) {
    if (!__DEV__ && __CLIENT__) {
      const loc = global.location;
      const next = nextState.location;
      if (
        /*http2() && */ loc.protocol === 'http:' &&
        !/localhost/.test(loc.hostname)
      ) {
        global.location.href = `https://${loc.hostname}${next.pathname}${
          next.search
        }${next.hash}`;
        return;
      }
    }
    done();
  }

  return (
    <Route path="/" component={App} onEnter={initCheck}>
      <Route path="/vis/:id" component={Dwelling} />
      <Route onEnter={authCheck}>
        <Route path="/signup" component={Signup} />
        <Route path="/login" component={Login} />
      </Route>
      <Route path="/reset-password" component={ResetPassword} />
      <Route path="/profile/verify" component={VerifyUser} />
      <Route path="/profile" onEnter={requireAuth} component={Profile}>
        <Route
          path="subscription"
          component={Subscription}
          onEnter={preferSSL}
        />
        <Route path="invoice/:id" component={Transaction} />
        <Route path="tenant" component={Tenant} />
        <Route path="password" component={ProfileChangePassword} />
        <Route path="boligagent" component={ProfileBoligAgents} />
        <IndexRoute component={ProfileMain} />
      </Route>
      <Route path="/boligagent">
        <Route path="verify" component={VerifyBoligagent} />
        <Route path=":token" component={ChangeBoligagent} />
      </Route>
      <Route component={ShowSearch}>
        <Route path="/info">
          <Route path="contact" component={Contact} />
          <Route path="about" component={About} />
          <Route path="faq" component={Faq} />
          <Route path="partners" component={Partners} />
          <Route path="terms" component={Terms} />
          <Route path="afmelding" component={UnsubscriptionForm} />
          <Route path="klagemulighed" component={Complain} />
          <Route path="raad-om-boligsoegning" component={Welcome} />
        </Route>
        <Route path="/byer" component={Cities} />
        <Route path="/search" component={Search} onEnter={validateSearch} />
        <Route path="/:city" component={Area} />
        <IndexRoute component={Frontpage} />
        <Route path="*" component={NotFound} />
      </Route>
    </Route>
  );
};
